import React from "react";
import Navbar from "./Navbar";

const Container = ({ children, navbarProps }) => {
  return (
    <>
      <Navbar {...navbarProps} />
      <main className="rounded-box">{children}</main>
    </>
  );
};

export default Container;
